import React from 'react';
import ProRateField from './ProRateField';

interface ProRateFieldGroupProps {
  settingsNestedOperator: string;
  isMarket: boolean;
  isLocation: boolean;
}

const ProRateFieldGroup = ({
  settingsNestedOperator,
  isMarket,
  isLocation,
}: ProRateFieldGroupProps) => {
  const fields = [];

  // Market-specific fields
  if (isMarket) {
    fields.push(
      <ProRateField
        key="8hr-pro-rate"
        label="8hr Pro Rate"
        nestedOperator={settingsNestedOperator}
        useBlendedRate={false}
        applyLocationTypeMarkup={false}
        isUsingLocationType
      />,
      <ProRateField
        key="12hr-pro-rate"
        label="12hr Pro Rate"
        nestedOperator={settingsNestedOperator}
        useBlendedRate={true}
        applyLocationTypeMarkup={false}
        isUsingLocationType
      />,
    );
  }

  // General fields
  fields.push(
    <ProRateField
      key="general-8hr-pro-rate"
      label={`${!isLocation ? '8hr ' : ''}${isMarket ? 'Location Markup' : ''} Pro Rate`}
      nestedOperator={settingsNestedOperator}
      useBlendedRate={false}
      applyLocationTypeMarkup={true}
      isUsingLocationType={isMarket}
    />,
  );

  if (!isLocation) {
    fields.push(
      <ProRateField
        key="general-12hr-pro-rate"
        label={`12hr ${isMarket ? 'Location Markup' : ''} Pro Rate`}
        nestedOperator={settingsNestedOperator}
        useBlendedRate={true}
        applyLocationTypeMarkup={true}
        isUsingLocationType={isMarket}
      />,
    );
  }

  return fields;
};

export default ProRateFieldGroup;
